<ng-container *ngIf="shopItems?.length > 0">
  <!-- Row Layout -->
  <ng-container *ngIf="layout === ShopSectionLayout.Row">
    <lib-section-header title="Vorteilswelt"
                        titleIcon="shopping_bag"
                        [colorScheme]="colorScheme"
    ></lib-section-header>
    <lib-slider *ngIf="layout === ShopSectionLayout.Row" [colorScheme]="colorScheme" class="slider">
      <lib-slider-item class="slider-item rise-on-hover" *ngFor="let item of shopItems">
        <lib-shop-item-card
          class="slider-card"
          [item]="item"
          [colorScheme]="colorScheme">
        </lib-shop-item-card>
      </lib-slider-item>
    </lib-slider>
  </ng-container>
  <!-- Grid Layout -->
  <div *ngIf="layout === ShopSectionLayout.Grid" class="grid">
    <lib-shop-item-card
      *ngFor="let item of shopItems"
      class="grid-card rise-on-hover"
      [item]="item"
      [colorScheme]="colorScheme">
    </lib-shop-item-card>
  </div>
</ng-container>
